import "./index.css";
import React, { useEffect, lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import Home from "./Pages/Home/Home"; 
import AOS from "aos";
import "aos/dist/aos.css";

// Skeleton Fallback
const SkeletonLoader = () => (
  <div className="p-8 pb-[100vh] text-center text-gray-500 animate-pulse">
    <div className="h-4 w-1/3 bg-gray-300 mx-auto mb-4 rounded"></div>
    <div className="h-4 w-1/4 bg-gray-300 mx-auto mb-2 rounded"></div>
    <div className="h-4 w-1/5 bg-gray-300 mx-auto rounded"></div>
  </div>
);

// Lazy Pages
const Contact = lazy(() => import("./Pages/Contact/Contact"));
const About = lazy(() => import("./Pages/About/About"));
const CostCalculator = lazy(() => import("./Pages/Home/CostCalculator"));
const Testimonials = lazy(() => import("./Pages/Home/Testimonials"));
const GoldenVisa = lazy(() => import("./Pages/GoldenVisa/GoldenVisaHome"));
const Mainland = lazy(() => import("./Pages/CompanyFormation/Mainland/Mainland"));
const Freezone = lazy(() => import("./Pages/CompanyFormation/Freezone/Freezone"));
const Offshore = lazy(() => import("./Pages/CompanyFormation/Offshore/Offshore"));
const Corporatebankaccountopening = lazy(() =>
  import("./Pages/Corporate Services/Corporate-Bank-Account-Opening/corporatebankaccountopening")
);
const AccountandBookeeping = lazy(() =>
  import("./Pages/Corporate Services/Accout and Bookeeping Service/AccountandBookeeping")
);
const ProServices = lazy(() =>
  import("./Pages/Corporate Services/Pro Services/ProServices")
);
const OtherServices = lazy(() =>
  import("./Pages/Corporate Services/Other Services/OtherServices")
);
const CompanyFormation = lazy(() =>
  import("./Pages/Corporate Services/Liscensing Service/CompanyFormation")
);
const Blogs = lazy(() => import("./Pages/Blogs/Blogs"));
const BlogDetails = lazy(() => import("./Pages/BlogDetails/BlogDetails"));
const CompanyProfile = lazy(() => import("./Pages/CompanyProfile/CompanyProfile"));

function App() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-LQLSYVMTYP", {
        page_path: location.pathname,
      });
    }
  }, [location]);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} /> {/* ⏱ Eager */}
        <Route
          path="/companyProfile"
          element={
            <Suspense fallback={<SkeletonLoader />}>
              <CompanyProfile />
            </Suspense>
          }
        />
        <Route
          path="/testimonials"
          element={
            <Suspense fallback={<SkeletonLoader />}>
              <Testimonials />
            </Suspense>
          }
        />
        <Route
          path="/about"
          element={
            <Suspense fallback={<SkeletonLoader />}>
              <About />
            </Suspense>
          }
        />
        <Route
          path="/mainland"
          element={
            <Suspense fallback={<SkeletonLoader />}>
              <Mainland />
            </Suspense>
          }
        />
        <Route
          path="/freezone"
          element={
            <Suspense fallback={<SkeletonLoader />}>
              <Freezone />
            </Suspense>
          }
        />
        <Route
          path="/offshore"
          element={
            <Suspense fallback={<SkeletonLoader />}>
              <Offshore />
            </Suspense>
          }
        />
        <Route
          path="/goldenVisa"
          element={
            <Suspense fallback={<SkeletonLoader />}>
              <GoldenVisa />
            </Suspense>
          }
        />
        <Route
          path="/company-formation"
          element={
            <Suspense fallback={<SkeletonLoader />}>
              <CompanyFormation />
            </Suspense>
          }
        />
        <Route
          path="/pro-services"
          element={
            <Suspense fallback={<SkeletonLoader />}>
              <ProServices />
            </Suspense>
          }
        />
        <Route
          path="/accounting-bookkeeping"
          element={
            <Suspense fallback={<SkeletonLoader />}>
              <AccountandBookeeping />
            </Suspense>
          }
        />
        <Route
          path="/corporate-bank-account-opening"
          element={
            <Suspense fallback={<SkeletonLoader />}>
              <Corporatebankaccountopening />
            </Suspense>
          }
        />
        <Route
          path="/other-services"
          element={
            <Suspense fallback={<SkeletonLoader />}>
              <OtherServices />
            </Suspense>
          }
        />
        <Route
          path="/blogs"
          element={
            <Suspense fallback={<SkeletonLoader />}>
              <Blogs />
            </Suspense>
          }
        />
        <Route
          path="/blog-details"
          element={
            <Suspense fallback={<SkeletonLoader />}>
              <BlogDetails />
            </Suspense>
          }
        />
        <Route
          path="/costcalculator"
          element={
            <Suspense fallback={<SkeletonLoader />}>
              <CostCalculator />
            </Suspense>
          }
        />
        <Route
          path="/contact"
          element={
            <Suspense fallback={<SkeletonLoader />}>
              <Contact />
            </Suspense>
          }
        />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
